import AmbientEgg from "./AmbientEgg";

/**
 * A tesseract, on the landing page.
 *
 * In Heinlein's "—And He Built a Crooked House" (1941) an architect builds a
 * house in the shape of an unfolded tesseract — a four-dimensional cube laid out
 * flat, the way a cardboard cross folds into a box. An earthquake folds it, and
 * the people inside find the rooms lead somewhere other than where they went in.
 *
 * Which makes it the right thing on a front door. This is the page that promises
 * to map the narrative threads of consciousness for the future-literate; a
 * hypercube is the oldest possible way of saying "there is another direction you
 * have not looked in yet".
 *
 * Per rendering-animate-svg-wrapper the rotation sits on the span, not the svg.
 * The inner cube's pulse stays inside, since it is a nested transform.
 */
const Tesseract = () => (
  <AmbientEgg
    label="A tesseract. Heinlein built a house as one, and an earthquake folded it up."
    width={44}
    height={44}
    motion="hold"
    align="center"
    tip="top"
  >
    <span className="block">
      <style>{`
        /* Slow enough to read as drift rather than a loading state. */
        @keyframes tesseract-turn { to { transform: rotate(360deg); } }
        /* The inner cube swelling toward the outer is the whole illusion: in a
           real hypercube neither is inside the other, the projection just makes
           it look that way. Offset from the rotation so they never sync. */
        @keyframes tesseract-breathe {
          0%, 100% { transform: scale(1); opacity: 0.75; }
          50%      { transform: scale(1.55); opacity: 1; }
        }
        .tesseract-turn    { animation: tesseract-turn 48s linear infinite;
                             transform-origin: 50% 50%; }
        .tesseract-breathe { animation: tesseract-breathe 11s ease-in-out infinite;
                             transform-box: fill-box; transform-origin: center; }
      `}</style>

      <span className="tesseract-turn block">
        <svg
          width="44"
          height="44"
          viewBox="0 0 60 60"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="text-cyan-400"
        >
          {/* outer cell */}
          <rect x="7" y="7" width="46" height="46" rx="1" />
          {/* the struts joining the two cells, drawn before the inner cell so
              the inner one reads as sitting on top */}
          <path d="M7 7 L21 21" />
          <path d="M53 7 L39 21" />
          <path d="M53 53 L39 39" />
          <path d="M7 53 L21 39" />
          {/* inner cell */}
          <rect className="tesseract-breathe" x="21" y="21" width="18" height="18" rx="1" />
        </svg>
      </span>
    </span>
  </AmbientEgg>
);

export default Tesseract;
